import * as Yup from 'yup'
import { BaseEntity } from '../../../../shared/models/ApiModels'

// VehicleGroupModel.ts
export interface IVehicleGroupModel extends BaseEntity{ 
  groupName: string                                  //1 zorunlu 
  driverAge: number                                 // 2 zorunlu
  youngDriverAge: number                          // 3
  licenseYear: number                             // 4
  youngLicenseYear: number                       // 5
  provisionFee: number                   //6
  provisionFeeCurrency: string                 // 7 
  exemptionFee: number                // 8
  fuelPrice: number                  //9
  dailyKmLimit: number                      // 10 
  maxKmLimit: number                       // 11 
  kmFee: number                  //12  
  webSort: number                        //13 
  creditCardRequired: boolean           // 14
  upgradeSort: number                  // 15 
  bodyType: string                    //16
  sippCode: string                    // 17 
  webCarBrand: string               // 18
  webCarType: string               //zorunlu  //19
  seatCount: number                //zorunlu   // 20 
  doorCount: number              //21
  bigTrunkCount: number         //22
  smallTrunkCount: number      //23
  description: string         // 24
  fuelType: string           //25 
  transmission: string      //26 
  postPayRate: number          //27
  specialCode: string                 //28 
  webId: number                      //29 
  serviceId: number                  //30
  carGroupCode: number               // 31
  isPassive: boolean                 //32

}


export const initialVehicleGroup: IVehicleGroupModel = {
  id: '',             // ZORUNLU ALANLAR  
  groupName: '',    
  driverAge: 0,    
  webCarType: '',  
  seatCount: 0,                       // OPSİYONEL ALANLAR
  sippCode: '',    
  webCarBrand: '',
  youngDriverAge: 0,
  licenseYear: 0,
  youngLicenseYear: 0,
  doorCount: 0,
  provisionFee: 0,
  provisionFeeCurrency: '1',
  bigTrunkCount: 0,
  exemptionFee: 0,
  smallTrunkCount: 0, 
  fuelPrice: 0,
  description: '',
  dailyKmLimit: 0,
  fuelType: '',
  maxKmLimit: 0,
  transmission: '',
  kmFee: 0,
  postPayRate: 0,
  webSort: 0,
  specialCode: '',
  creditCardRequired: false,
  webId: 0,
  serviceId: 0,
  upgradeSort: 0,
  bodyType: '',
  carGroupCode: 0,
  isPassive: false,
  
}


export const validationVehicleGroup = Yup.object().shape({
  // ZORUNLU ALAN VALİDASYONLARI
  groupName: Yup.string()
    .required('Grup adı zorunludur')
    .min(2, 'En az 2 karakter olmalıdır')
    .max(100, 'En fazla 100 karakter olabilir'),

  driverAge: Yup.number()
    .required('Sürücü yaşı zorunludur')
    .min(18, 'En az 18 yaşında olmalıdır'),

  youngDriverAge: Yup.number() 
    .min(18, 'En az 18 yaşında olmalıdır'),

  licenseYear: Yup.number()
     .required('Ehliyet yılı zorunludur')
  .min(2, 'Ehliyet yılı en az 2 olmalıdır'),   // min 2 olacak

  youngLicenseYear: Yup.number() 
  .min(1, 'Genç ehliyet yılı en az 1 olmalıdır'),  // min 1 olacak

  provisionFee: Yup.number()
    .required('Provizyon ücreti zorunludur')
    .min(0, 'Negatif olamaz'),

  provisionFeeCurrency: Yup.string()
    .required('Provizyon para birimi zorunludur'),

  exemptionFee: Yup.number() 
    .min(0, 'Negatif olamaz'),

  fuelPrice: Yup.number() 
    .min(0, 'Negatif olamaz'),

  dailyKmLimit: Yup.number() 
    .min(0, 'Negatif olamaz'),

  maxKmLimit: Yup.number() 
    .min(0, 'Negatif olamaz'),

  kmFee: Yup.number() 
    .min(0, 'Negatif olamaz'),
 

  sippCode: Yup.string()
  .required('SIPP kodu zorunludur')
  .max(4, 'SIPP kodu en fazla 4 karakter olabilir'),  // max 4 karakter
 

  fuelType: Yup.string()
    .required('Yakıt tipi zorunludur'),

  transmission: Yup.string()
    .required('Vites tipi zorunludur'), 
 
});
 

